import {documentLoadEvent} from "../../webpack/modules/events";
import {getAWCFromURL, sendAWCToCart} from "../../webpack/modules-optimized/awin";

documentLoadEvent(function() {
    getAWCFromURL();
    sendAWCToCart();
});